<template>
	<div class="patients">
		<md-card>
			<md-card-header>
				<div class="md-title">{{$t("admin.patients")}}</div>
			</md-card-header>
			<md-card-content class="row">
				<md-checkbox v-model="showHidden">Rejtett felhasználók megjelenítése</md-checkbox>
			</md-card-content>
		</md-card>

		<md-table-card>
			<md-table md-sort="name" md-sort-type="asc" @sort="onSort">
				<md-table-header>
					<md-table-row>
						<md-table-head>{{$t("admin.image")}}</md-table-head>
						<md-table-head md-sort-by="name">{{$t("name")}}</md-table-head>
						<md-table-head md-sort-by="email">{{$t("email")}}</md-table-head>
						<md-table-head>{{$t("admin.summary")}} ({{$t("admin.lastFourWeek")}})</md-table-head>
						<md-table-head>{{$t("admin.data")}}</md-table-head>
						<md-table-head>Rejtve</md-table-head>
					</md-table-row>
				</md-table-header>

				<md-table-body>
					<md-table-row v-for="(patient, index) in patientsPage" :key="index" :md-item="patient" v-if="showHidden || !patient.hidden">
						<md-table-cell>
							<md-avatar class="avatar">
								<img :src="patient.avatar">
								<md-tooltip md-direction="bottom"><img class="large-avatar" :src="patient.avatar"/></md-tooltip>
							</md-avatar>
						</md-table-cell>
						<md-table-cell :key="'name'" :md-numeric="false"><span v-bind:class="{ 'anonym': !patient.name }">{{patient.name ? patient.name : "Nincs név megadva"}}</span></md-table-cell>
						<md-table-cell :key="'email'" :md-numeric="false">{{patient.email}}</md-table-cell>
						<md-table-cell><div>
							<b>{{patient.additionalFactors.symptomCount.value}}</b> - {{$t("admin.numberofsymptoms")}}</br>
							<b>{{patient.additionalFactors.rescueMedicationCount.value}}</b> - {{$t("admin.rescueMedUsage")}}
						</div></md-table-cell>
						<md-table-cell><md-button class="md-primary" v-on:click="showPatient(patient)">Adatok</md-button></md-table-cell>
						<md-table-cell>
							<md-switch v-model="patient.hidden" class="md-primary"></md-switch>
						</md-table-cell>
					</md-table-row>
				</md-table-body>
			</md-table>
			<md-table-pagination
			:md-size="size"
			:md-total="patients.length"
			md-page="1"
			md-label="Rows"
			md-separator="of"
			:md-page-options="[5, 10, 25, 50]"
			@pagination="onPagination"></md-table-pagination>
		</md-table-card>

	</div>
</template>

<script>
	import Api from '../../../generated'
	import _ from 'lodash'

	var images = require.context('../../assets/', false, /\.png$/);

	export default {
		data(){
			return {
				patients: [],
				patientsPage: [],
				showHidden: false,
				hidden: false,
				profile: {},
				sort: {
					name: "name",
					type: "asc"
				},
				page: 1,
				size: 25
			}
		},
		watch: {
			patients: {
				handler: function (newPatients) {
					if(this.profile){
						console.log(JSON.stringify(this.profile));
						for(let patient of newPatients){
							if(patient.hidden){
								if(!_.includes(this.profile.hiddenPatients, patient._id)){
									this.profile.hiddenPatients.push(patient._id);
								}
							}else{
								if(_.includes(this.profile.hiddenPatients, patient._id)){
									_.pull(this.profile.hiddenPatients, patient._id);
								}
							}
						}
						Api.ApiClient.instance.updateProfile(this.profile, (error, data, response) => {
							if (error) {
								console.error(error);
							}
						});
					}
				},
				deep: true
			}
		},
		methods: {
			refreshTable(){
				var ind = (this.page-1)*this.size;
				this.patientsPage = this.patients.slice(ind, ind + this.size);
			},
			onSort(sort){
				this.sort = sort;
				this.patients.sort((a, b) => {
					return a[this.sort.name].localeCompare(b[this.sort.name]);
				});
				if(this.sort.type == "desc"){
					this.patients.reverse();
				}
				this.refreshTable()
			},
			onPagination (e) {
				this.size = e.size;
				this.page = e.page;
				this.refreshTable();
			},
			showPatient(patient){
				this.$router.push('/admin/patient/' + patient._id);
			}
		},
		mounted(){
			this.$bus.$emit('showLoading', true);
			Api.ApiClient.instance.getPatientList({}, (error, data, response) => {
				if (error) {
					console.error(error);
				} else {
					for(var patient of data){
						if(!patient.name){
							patient.name = "";
						}
						if(!patient.avatar){
							patient.avatar = images('./placeholder.png');
						}
					}
					this.patients = data;
				}
				this.onSort(this.sort);

				Api.ApiClient.instance.profile((error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						this.profile = data.data;
						if(this.profile.hiddenPatients){
							for(var patient of this.patients){
								if(_.includes(this.profile.hiddenPatients, patient._id)){
									patient.hidden = true;
								}
							}
						}else{
							this.profile.hiddenPatients = [];
						}
					}
					this.$bus.$emit('showLoading', false);
				});

			})

			
		}
	}
</script>

<style scoped>
	.anonym{
		color: #a1a1a1;
	}
	.avatar{
		width: 64px;
		height: 64px;
		border-radius: 8px;
	}
	.large-avatar{
		width: 256px;
		height: 256px;
		border-radius: 8px;
	}
</style>



// WEBPACK FOOTER //
// PatientList.vue?763076d9